export default __webpack_public_path__ + "static/17_30-0d016aa25ceba595d0feab5cfe714da6.png";